import React from 'react';
import './Field.scss';

interface FieldProps {
  label: string;
  value: string | number | React.ReactNode;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

const Field: React.FC<FieldProps> = ({
  label,
  value,
  className = '',
  labelClassName = '',
  valueClassName = '',
}) => {
  return (
    <div className={`field-component ${className}`}>
      <span className={`field-label ${labelClassName}`}>
        {label}
      </span>
      <span className={`field-value ${valueClassName}`}>
        {value}
      </span>
    </div>
  );
};

export default Field;
